import cn from 'classnames'

import {
  PARTNERS_COVERAGE_COLUMN_KEYS,
  PARTNERS_COVERAGE_TABLE_TITLES,
  TPartnersCoverageTableKey,
} from '../../../../configs/coverageTables'
import { formatCoverageValue } from '../../../../lib'
import { IPartnersCoverageRow } from '../../../../model'

import { CoverageTableColgroup } from './CoverageTableColgroup'

import styles from './CoverageTable.module.scss'

interface ICoverageTableProps {
  tableKey: TPartnersCoverageTableKey
  rows: IPartnersCoverageRow[]
}

export const CoverageTable = ({ tableKey, rows }: ICoverageTableProps) => {
  if (!rows?.length) {
    return null
  }

  return (
    <div className={cn(styles.root, styles[tableKey])}>
      <div className={styles.plate}>{PARTNERS_COVERAGE_TABLE_TITLES[tableKey]}</div>

      <div className={styles.card}>
        <table className={styles.table}>
          <CoverageTableColgroup />
          <tbody>
            {rows.map((row) => (
              <tr key={row.rowLabel} className={styles.row}>
                <th className={styles.rowLabel} scope="row">
                  {row.rowLabel}
                </th>
                {PARTNERS_COVERAGE_COLUMN_KEYS.map((columnKey) => (
                  <td key={columnKey} className={styles.cell}>
                    {formatCoverageValue(row, columnKey)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
